// extracted by css-extract-rspack-plugin
export default {"wall":"Ticker-module__wall","row":"Ticker-module__row","cell":"Ticker-module__cell","logo":"Ticker-module__logo"};